export default {
	functional: true,
	name: 'BalanceTag',
	props: {
		text: {
			type: String,
			require: true,
		},
	},
	render(h, context) {
		return h(
			'span',
			{
				class: 'global-balance-tag-box',
			},
			[
				h('img', {
					class: 'tag-icon',
					domProps: {
						src: require('@/assets/images/welfare/red.png'),
					},
				}),
				h(
					'span',
					{
						class: 'tag-num',
					},
					context.props.text
				),
			]
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/common/BalanceTag.js